export const env = import.meta.env.VITE_ENV || 'dev';

// TODO: set this env variable in Capacitor to enable AppCalendarService
export const isCapacitor = import.meta.env.VITE_CAPACITOR_BUILD;

export const mode = {
  maintenance: false,
  listeners: [],
  set(value) {
    this.maintenance = value === 'maintenance';
    this.listeners.forEach((listener) => {
      listener(this);
    });
  },
  onChange(listener) {
    this.listeners.push(listener);
  },
};

export const DEFAULT_SEARCH_RANGE_IN_MILES = 50;

export const sentryDSN = 'https://eb2ed9d944e74defadbdab4bb9296657@sentry.io/1501673';

const urls = {
  dev: {
    apiURL: 'http://localhost:8000/graphql/',
    adminURL: 'http://localhost:8000/admin/',
    mediaBaseURL: 'http://localhost:8000/',
  },
  nonprod: {
    apiURL: `https://api-${env}.dev.vetcoapp.com/graphql/`,
    adminURL: `https://api-${env}.dev.vetcoapp.com/admin/`,
    mediaBaseURL: 'https://storage.dev.vetcoapp.com/media/',
  },
  prod: {
    apiURL: 'https://api.vetcoapp.com/graphql/',
    adminURL: 'https://api.vetcoapp.com/admin/',
    mediaBaseURL: 'https://storage.vetcoapp.com/media/',
  },
};

const { apiURL, adminURL, mediaBaseURL } = urls[env] || urls.nonprod;
const mediaURL = (path) => {
  if (!path) {
    return '';
  }

  if (path.startsWith('http') || path.startsWith('blob:')) {
    return path;
  }

  return `${mediaBaseURL}${path}`;
};

export {
  apiURL,
  adminURL,
  mediaURL,
};
